<template>
    <div>
      <el-drawer @reload="$reloadHandle"
                 :title="'调整金额'" size="30%"
                 :before-close="handleClose"
                 :visible.sync="drawer"
                 direction="rtl"
                 :modal-append-to-body="true"
                 custom-class="demo-drawer"
                 ref="drawer">

        <div class="demo-drawer__content">
          <el-form :model="formData">
            <el-form-item label="安装调整金额">
              <el-input placeholder="请输入金额" v-model="formData.instAdjustAmount" style="width: 110px;"></el-input>
            </el-form-item>
            <el-form-item label="维修调整金额">
              <el-input placeholder="请输入金额" v-model="formData.wxAdjustAmount" style="width: 110px;"></el-input>
            </el-form-item>
            <el-form-item label="其他调整金额">
              <el-input placeholder="请输入金额" v-model="formData.otherAdjustAmount" style="width: 110px;"></el-input>
            </el-form-item>
          </el-form>
          <el-form :model="formData">
            <el-form-item label="调整原因">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}"
                        v-model="formData.adjustReason" autocomplete="off" ></el-input>
            </el-form-item>
          </el-form>
          <el-form :model="formData">
            <div class="d-item">
              <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                <div class="title first"><b>附件列表</b></div>
                <el-upload style="display:flex; float: right" class="upload-demo" ref="upload"
                           :action="api.uploadFileUrl"  :show-file-list="false" :on-progress="upVideo"
                           :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }" :headers="headers"
                           :auto-upload="true">
                  <el-button type="primary" class="button-sty btn_zdy">
                    <i class="el-icon-plus"></i>
                    附件
                  </el-button>
                </el-upload>
              </div>
              <div>
                <vxe-table style="margin-top: 0px;" :stripe="true"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                           @checkbox-all="selectChangeEvent" :data="fileList">
                  <vxe-column type="checkbox" width="40" />
                  <vxe-column field="fileName" title="附件名称" width="400">
                    <template #default="{ row }">
                      <a :href="row.fileUrl" :download="row.name">{{ row.fileName }}</a>
                    </template>
                  </vxe-column>
                  <vxe-column title="操作" width="60">
                    <template #default="{ row }">
                      <div @click="deleteFile(row)">
                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>
            </div>

          </el-form>


        <div class="demo-drawer__footer" style="position: absolute;
            bottom: 5px; right: 5px;">
            <el-button @click="cancelForm">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
          </div>
        </div>
      </el-drawer>
  		<el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList"
			style="z-index: 3000!important;" />
    </div>
  </template>
  <script>
import store from "@/store";
// 图片组件
import photoUpload from "@/components/formItem/photoUpload.vue"

  import api from "@/api/projectApi";
import { echoFileFormat, uploadFileFormat } from "@/util/uploadFormat";

  export default {
    inject: ['reload'],
    name: 'edit',
    props: ['id','wxAdjustAmount','instAdjustAmount','otherAdjustAmount','adjustReason','pic1','pic2','pic3'],
    components: {
      photoUpload,
		'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
	},
    created() {
      console.log('askdfksdfk', this.id,this.adjustAmount,this.adjustReason)
      this.formData.settleId = this.id
      this.formData.wxAdjustAmount = this.wxAdjustAmount
      this.formData.instAdjustAmount = this.instAdjustAmount
      this.formData.otherAdjustAmount = this.otherAdjustAmount
      // this.formData.pic1 = this.picList1
      // this.formData.pic2 = this.picList2
      // this.formData.pic3 = this.picList3
    },
    watch: {
		// picList1: {
		// 	handler(newVal, oldVal) {
		// 		this.formData.userPhoto = uploadFileFormat(newVal)
		// 		console.log(this.formData)
		// 	},
		// 	deep: true, // 加这个属性，深度监听
		// },
		// picList2: {
		// 	handler(newVal, oldVal) {
		// 		this.formData.snSiteInfoDTO.abilityPhoto = uploadFileFormat(newVal)
		// 	},
		// 	deep: true, // 加这个属性，深度监听
		// },
		// picList3: {
		// 	handler(newVal, oldVal) {
		// 		this.formData.snSiteInfoDTO.shopPhoto = uploadFileFormat(newVal)
		// 	},
		// 	deep: true, // 加这个属性，深度监听
		// },
		// file: {
		// 	handler(newVal, oldVal) {
		// 		this.formData.snSiteInfoDTO.contractFile = uploadFileFormat(newVal)
		// 	},
		// 	deep: true, // 加这个属性，深度监听
		// },
	},
    computed: {
		api() {
			return api
		},
		headers: function () {
			const tenantId = store.getters.userInfo.tenantId
			return {
				'Authorization': "Bearer " + store.getters.access_token,
				'TENANT-ID': tenantId
			};
		}
	},
    data() {
      return {
        fileList: [],
        file: [],
        dialogImageUrl: '',
        dialogImageUrlList: [],
        dialogVisible: false,
        uploadDisabled: false,

        // picList1: [],
        // picList2: [],
        // picList3: [],
        formData: {
          pic1:'',
          pic2:'',
          pic3:'',
          adjustReason: null,
          wxAdjustAmount: 0,
          instAdjustAmount: 0,
          otherAdjustAmount: 0,
          remark: null,
          id: null,
          type: null,
          sfBatchSettleInvoiceFileList: [],
        },
        drawer: true,
      }
    },
    methods: {
      closeImgViewer() {
			this.dialogVisible = false
		},
		//点击查看图片
		handlePictureCardPreview(file) {
			this.dialogImageUrlList = [file.url]
			this.dialogVisible = true;
			// console.log(fileList, "已上传文件")
		},
		handleImageChange(fileList) {
			if (fileList.length > 1) {
				fileList.splice(0, 1);
			}
		},
		// handleRemove1() {
		// 	this.picList1 = []
		// },
		// handleSuccess1(res, file, fileList) {
		// 	console.log(res.data.url, "url")
		// 	this.picList1 = echoFileFormat(res.data.url)
		// },
		// handleRemove2() {
		// 	this.picList2 = []
		// },
		// handleSuccess2(res, file, fileList) {
		// 	console.log(res.data.url, "url")
		// 	this.picList2 = echoFileFormat(res.data.url)
		// },
		// handleRemove3() {
		// 	this.picList3 = []
		// },
		// handleSuccess3(res, file, fileList) {
		// 	console.log(res.data.url, "url")
		// 	this.picList3 = echoFileFormat(res.data.url)
		// },
    // 确定
    confirm() {
      if (!this.formData.otherAdjustAmount&&!this.formData.wxAdjustAmount&&!this.formData.instAdjustAmount) {
        this.$message.error('调整金额必填')
        return false;
      }
      if (!this.formData.adjustReason) {
        this.$message.error('调整原因必填')
        return false;
      }
      this.formData.sfBatchSettleInvoiceFileList = this.fileList
      this.$http({
          url: api.sfBatchSettle.adjustAmountDataUrl,
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$message.success('操作成功')
          this.visiable = false
          this.$emit('update:visiable', this.visiable)
          this.$emit('goBackIndex')
        })
    },
      handleFileSuccess(res, file, fileList) {
        let url = res.data.url
        let fileName = file.name
        console.log(url, "url")
        console.log(fileName, "name")
        this.fileList.push({
          fileName: fileName,
          fileUrl: url
        })
        this.$mask.close()

      },

      deleteFile(row) {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          console.log(row, 'delete')
          this.fileList = this.fileList.filter(item => item.url !== row.url)
        })
      },

      selectChangeEvent(data) {
        console.log('选中数据', data)
        this.selectedData = data.records
      },

    // 上传成功
    handleSuccess4(res, file, fileList) {

    // 上传成功后，隐藏上传按钮
    this.upload_btn = true;
    console.log(res.data.url,"url")
    this.company.picList =[
      {url: res.data.url}
    ]
  },
      handleRemove4(response, file, fileList) {
        // 删除成功后，显示上传按钮
        // this.company.picList=[]
        this.upload_btn = false;
        // console.log(this.company.picList,"this.company.picList删除后");
      },
      // confirm() {
      //   this.drawer = false;
      //   this.handleClose()
      // },
      cancelForm() {
        this.visiable = false
        this.$emit('update:visiable', this.visiable)
      },
      handleClose() {
        this.cancelForm()
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

/* 推荐，实现简单 */
.el-upload-list__item.is-ready,.el-upload-list__item.is-uploading {
  display: none !important;
}

.pic_3{
  height: 100px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  .pic3_title{
    font-size: 12px;
    font-weight: 400;
    color: #606266;
    margin-right: 10px;
  }
}
  </style>
